import { HOW_IT_STAYS_GOOD } from '../content';

export default function HowItStaysGood() {
  return (
    <section id="how" className="py-20 md:py-28 border-t border-border" data-testid="how-it-stays-good">
      <div className="max-w-[1040px] mx-auto px-6">
        <div className="max-w-[620px]">
          <h2 className="font-heading text-3xl md:text-4xl tracking-tight text-textp font-semibold">
            How it stays good
          </h2>
          <p className="mt-4 text-texts leading-relaxed">
            Generation gives you a disposable app. A launchpad scores the artifact against a contract and trains until it holds.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4">
          {HOW_IT_STAYS_GOOD.map((step, i) => (
            <div key={step.title} className="bg-surface border border-border rounded-xl p-6">
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 rounded-lg bg-accentSoft border border-accentLine flex items-center justify-center">
                  <i className={`${step.icon} text-accent text-base`} />
                </span>
                <span className="font-mono text-xs text-texts">0{i + 1}</span>
              </div>
              <h3 className="mt-4 text-base text-textp font-medium">{step.title}</h3>
              <p className="mt-2 text-sm text-texts leading-relaxed">{step.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
